function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 19.5,
  fill: "white",
  stroke: "#55BB91"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.0002 24.17L12.8302 20L11.4102 21.41L17.0002 27L29.0002 15L27.5902 13.59L17.0002 24.17Z",
  fill: "#55BB91"
});

var SvgCheckRounded = function SvgCheckRounded(props) {
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/check-rounded.47ae2980.svg";
export { SvgCheckRounded as ReactComponent };